import React, { useState, useEffect } from 'react';
import { ProductCarouselSlide, ProductCarousel, ProductImage } from 'anf-core-react';
import ImagePlaceholder from './ImagePlaceholder';
import useImageCarousel from './CarouselHook';

export default function ProductMainImages({
  productImages,
  onClick,
  handleImageErrorOrRemoval,
  tmntData,
  singleView,
  isMobile,

}) {
  const [isLoading, setIsLoading] = useState(true);

  const {
    setImageData, onKeyDown, visibleTabID, setVisibleTabID,
  } = useImageCarousel(tmntData, handleImageErrorOrRemoval);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = (imageId) => {
    setIsLoading(false);
    handleImageErrorOrRemoval(imageId);
  };

  useEffect(() => {
    setVisibleTabID('slide-1');
  }, [productImages, setVisibleTabID]);

  const setImageSlides = (imageData, index) => {
    const currentIndex = index + 1;
    const altText = tmntData.mainImageAltText.value;

    const newImageSlide = {
      id: `slide-${currentIndex}`,
      isVisible: visibleTabID === `slide-${currentIndex}`,
      key: `image ${currentIndex}`,
      labelledBy: `control-slide-${currentIndex}`,
    };

    return (
      <ProductCarouselSlide
        id={newImageSlide.id}
        isVisible={newImageSlide.isVisible}
        key={newImageSlide.key}
        labelledBy={newImageSlide.labelledBy}
      >
        {isLoading && (
        <ImagePlaceholder
          singleView={singleView}
          isMobile={isMobile}
        />
        )}
        <ProductImage
          alt={altText.replace('{0}', imageData.type)}
          classList="product-image-react"
          src={imageData.mainImageSrc}
          onClick={(event) => onClick(event, imageData)}
          onError={() => handleImageError(imageData.imageId)}
          onLoad={handleImageLoad}
          data-size=""
        />
      </ProductCarouselSlide>
    );
  };

  const buildImagesObject = (productImagesArray) => {
    const imageButtons = [];
    const imageSlides = [];

    productImagesArray?.forEach((imageData, index) => {
      imageButtons.push(setImageData(imageData, index));
      imageSlides.push(setImageSlides(imageData, index));
    });

    return ({
      imageButtons,
      imageSlides,
    }
    );
  };

  const imagesData = buildImagesObject(productImages);
  const shouldShowControls = imagesData.imageButtons.length > 1;

  return (
    <ProductCarousel
      controls={{
        buttons: shouldShowControls
          ? imagesData.imageButtons : [],
        labelText: tmntData.thumbnailImagesAriaLabel.value,
        ariaLabel: tmntData.thumbnailImagesAriaLabel.value,
        onKeyDown: onKeyDown(imagesData.imageButtons),
      }}
      ariaLabel={tmntData.productCarouselAriaLabel.value}
      orientation="vertical"
      classListForTabButtons={!shouldShowControls ? 'hide-thumbnails' : ''}
    >
      { imagesData.imageSlides }
    </ProductCarousel>
  );
}
